/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoMarketCarBoxTransactionLogListRequest model module.
 * @module model/LogControllerDtoMarketCarBoxTransactionLogListRequest
 * @version 1.0
 */
class LogControllerDtoMarketCarBoxTransactionLogListRequest {
    /**
     * Constructs a new <code>LogControllerDtoMarketCarBoxTransactionLogListRequest</code>.
     * @alias module:model/LogControllerDtoMarketCarBoxTransactionLogListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        LogControllerDtoMarketCarBoxTransactionLogListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>LogControllerDtoMarketCarBoxTransactionLogListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoMarketCarBoxTransactionLogListRequest} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoMarketCarBoxTransactionLogListRequest} The populated <code>LogControllerDtoMarketCarBoxTransactionLogListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoMarketCarBoxTransactionLogListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('buyerAccount')) {
                obj['buyerAccount'] = ApiClient.convertToType(data['buyerAccount'], 'String');
            }
            if (data.hasOwnProperty('sellerAccount')) {
                obj['sellerAccount'] = ApiClient.convertToType(data['sellerAccount'], 'String');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('grade')) {
                obj['grade'] = ApiClient.convertToType(data['grade'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoMarketCarBoxTransactionLogListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoMarketCarBoxTransactionLogListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of LogControllerDtoMarketCarBoxTransactionLogListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['buyerAccount'] && !(typeof data['buyerAccount'] === 'string' || data['buyerAccount'] instanceof String)) {
            throw new Error("Expected the field `buyerAccount` to be a primitive type in the JSON string but got " + data['buyerAccount']);
        }
        // ensure the json data is a string
        if (data['sellerAccount'] && !(typeof data['sellerAccount'] === 'string' || data['sellerAccount'] instanceof String)) {
            throw new Error("Expected the field `sellerAccount` to be a primitive type in the JSON string but got " + data['sellerAccount']);
        }
        // ensure the json data is a string
        if (data['grade'] && !(typeof data['grade'] === 'string' || data['grade'] instanceof String)) {
            throw new Error("Expected the field `grade` to be a primitive type in the JSON string but got " + data['grade']);
        }

        return true;
    }


}

LogControllerDtoMarketCarBoxTransactionLogListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
LogControllerDtoMarketCarBoxTransactionLogListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
LogControllerDtoMarketCarBoxTransactionLogListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
LogControllerDtoMarketCarBoxTransactionLogListRequest.prototype['skip'] = undefined;

/**
 * @member {Date} beginDate
 */
LogControllerDtoMarketCarBoxTransactionLogListRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
LogControllerDtoMarketCarBoxTransactionLogListRequest.prototype['endDate'] = undefined;

/**
 * @member {String} buyerAccount
 */
LogControllerDtoMarketCarBoxTransactionLogListRequest.prototype['buyerAccount'] = undefined;

/**
 * @member {String} sellerAccount
 */
LogControllerDtoMarketCarBoxTransactionLogListRequest.prototype['sellerAccount'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoMarketCarBoxTransactionLogListRequest.prototype['nftUid'] = undefined;

/**
 * @member {String} grade
 */
LogControllerDtoMarketCarBoxTransactionLogListRequest.prototype['grade'] = undefined;






export default LogControllerDtoMarketCarBoxTransactionLogListRequest;

